import UserList from './UserList'

export default {
  list: UserList,
}
